import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import axios from '../../../util/Api';

const { Option } = Select;

const PassportSelect = () => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [passports, setPassports] = useState([]);

  useEffect(() => {
    setLoading(true);
    const url = `/passport/options`;
    axios.get(url).then(resp => {
      setPassports(resp.data);
      setLoading(false);
    }).catch(err => {});
  }, []);

  return (
    <>
      <Select
        defaultValue={formik.values.passport.id}
        onChange={(value) => formik.setFieldValue("passport.id", value)}
        placeholder="Masukkan Nama atau Personil atau No Identitas (Nomor/KITAS/Passport untuk WNA)"
        loading={loading}
        optionFilterProp="label"
        showSearch
      >
        {passports.map((passport, key) => {
          return <Option value={passport.id} key={`passport-${key}`} label={`${passport.identity.number} ${passport.name} ${passport.number}`}>
            {passport.number}
            <div className="gx-text-sm gx-text-muted">{passport.name}</div>
          </Option>
        })}
      </Select>
      <ErrorMessage component="div" name="passport.id" className="gx-mt-2 gx-text-red" />
    </>
  );
}

export default PassportSelect;